import React, { useState, useCallback } from "react";
import { Button } from "components/bootstrap";
import MessageFieldsEditModal from "./MessageFieldsEditModal";
import useSendFavoriteFieldTelemetry from "./hooks/useSendFavoriteFieldTelemetry";
const MessageEditFieldConfigurationAction = () => {
  const [showModal, setShowModal] = useState(false);
  const sendFavoriteFieldTelemetry = useSendFavoriteFieldTelemetry();
  const toggleEditMode = useCallback(() => setShowModal((prev) => !prev), []);
  const onClick = useCallback(() => {
    sendFavoriteFieldTelemetry("EDIT_OPEN");
    return toggleEditMode();
  }, [sendFavoriteFieldTelemetry, toggleEditMode]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "small", onClick, title: "Edit favorite fields" }, "Edit favorite fields"), showModal && /* @__PURE__ */ React.createElement(MessageFieldsEditModal, { toggleEditMode }));
};
export default MessageEditFieldConfigurationAction;
